class JSXHelper {
    public static BreakStringIntoParagraphs(str: string, nopadding: boolean = false, styleToApply: any = null, maxLines: number = null): JSX.Element {
        if (str == null) {
            return (
                <p key="___n"> </p>
            );
        }

        var noteLines: string[] = [];

        if (str.indexOf("\r\n") > -1)
            noteLines = str.split("\r\n");
        else if (str.indexOf("\n") > -1)
            noteLines = str.split("\n");
        else if (str.indexOf("\r") > -1)
            noteLines = str.split("\r");

        var noPadClass = nopadding ? "no-pad" : "tooltip";

        if (noteLines.length < 2) {
            return (
                <ul><li className={noPadClass} key="___n" style={styleToApply}>{str}</li></ul>
            );
        }

        var output = [];
        var addedLastLine = false;

        noteLines.forEach((n: string, idx: number) => {
            if (maxLines == null || idx < maxLines) {
                if ($.trim(n).length === 0) {
                    output.push(<li className={noPadClass} style={styleToApply} key={"_line_" + idx}>&nbsp;</li>);
                }
                else {
                    output.push(<li className={noPadClass} style={styleToApply} key={"_line_" + idx}>{n} </li>);
                }

                if (maxLines != null && idx + 1 == maxLines && !addedLastLine) {
                    output.push(<li className={noPadClass} style={styleToApply} key="_lastline">(...)</li>);
                    addedLastLine = true;
                }
            }
        });
        return (
            <ul>{output}</ul>
        );
    }

    public static getSiteDepartmentNameJSX(siteName: string, costCenterName: string, siteTruncateLimit: number = 40, costCenterTrucateLimit: number = 25): JSX.Element[] {
        let displayedSiteName = limitTextLength(siteName, siteTruncateLimit);
        let displayedCostCenter = limitTextLength(costCenterName, costCenterTrucateLimit);

        return [
            <div key="site-departement-name" className="displayHeaderNote">
                <div title={siteName}>
                    <span className="marginleft5">
                        {displayedSiteName}
                    </span>
                </div>
                {!IsNullOrWhiteSpace(costCenterName) && (
                    <div title={costCenterName}>
                        <span className="marginleft5">
                            {"- " + displayedCostCenter}
                        </span>
                    </div>
                )}
            </div>
        ];
    }
}

export { JSXHelper };
